import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=bd16b5ec&scoped=true&"
import script from "./RoleEdit.vue?vue&type=script&lang=js&"
export * from "./RoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd16b5ec",
  null
  
)

export default component.exports